import { render, staticRenderFns } from "./DbProductsTable.vue?vue&type=template&id=1e523bc6"
import script from "./DbProductsTable.vue?vue&type=script&lang=ts"
export * from "./DbProductsTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports